export const SET_LOADING = "SET_LOADING";
export const SET_NEWSLETTERS = "SET_NEWSLETTERS";
export const SET_ERROR = "SET_ERROR";
export const SET_EVENTS = "SET_EVENTS";
export const SET_FUNDING = "SET_FUNDING";
export const SET_MEMOS = "SET_MEMOS";
